import React from 'react';

import { SubHeading } from '../../components';
import { images } from '../../constants';
import './Chef.css';

const Chef = () => (
  <div className="app__bg app__wrapper section__padding">
    <div className="app__wrapper_img app__wrapper_img-reverse">
      <img src={images.chef} alt="chef_image" />
    </div>
    <div className="app__wrapper_info">
      <SubHeading title="Artist word" />
      <h1 className="headtext__cormorant">What we believe in</h1>

      <div className="app__chef-content">
        <div className="app__chef-content_quote">
          <img src={images.quote} alt="quote_image" />
          <p className="p__opensans"> </p>
        </div>
        <p className="p__opensans">As a womens beauty salon owner, we believe in celebrating the beauty, uniqueness, and individuality of every woman. We believe in providing a safe and inclusive space where women can enhance their natural beauty, boost their self-esteem, and feel empowered. Our mission is to inspire confidence and promote self-care, while building meaningful connections with our valued clients. </p>
      </div>

      <div className="app__chef-sign">
        <p>Sunita Gupta</p>
        <p className="p__opensans">Artist & Founder</p>
      </div>
    </div>
  </div>
);

export default Chef;
